import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ShieldCheck, ShieldX, Loader2 } from "lucide-react";
import { API } from "../lib/api";

const NCC_LOGO = "/ncc-logo.png";

export default function WorkmanVerifyPage() {
  const { id } = useParams();
  const [v, setV] = useState(null);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/workman-verify/${id}`)
      .then(async (r) => {
        if (!r.ok) throw new Error((await r.json()).detail || "Not found");
        setV(await r.json());
      })
      .catch((e) => setErr(e.message))
      .finally(() => setLoading(false));
  }, [id]);

  return (
    <div className="grid min-h-screen place-items-center bg-[#f5f7fc] p-4" data-testid="workman-verify-page">
      <div className="w-full max-w-sm border-4 border-ncc-navy bg-white">
        <div className="flex items-center gap-2 border-b-4 border-ncc-gold bg-ncc-navy px-4 py-3">
          <img src={NCC_LOGO} alt="SWMS-MPDB" className="h-9 w-9 rounded bg-white p-0.5" />
          <div className="text-xs font-black leading-tight text-white">SWMS-MPDB<br /><span className="font-mono text-[9px] font-normal text-blue-200">WORKMAN GATE VERIFICATION</span></div>
        </div>
        {loading ? (
          <div className="grid h-48 place-items-center"><Loader2 className="h-8 w-8 animate-spin text-ncc-navy" /></div>
        ) : err ? (
          <div className="p-6 text-center" data-testid="verify-error">
            <ShieldX className="mx-auto h-12 w-12 text-red-500" />
            <div className="mt-2 font-heading text-lg font-black text-red-600">INVALID QR CODE</div>
            <p className="mt-1 font-mono text-xs text-slate-500">{err}</p>
          </div>
        ) : (
          <>
            <div className={`px-4 py-3 text-center font-heading text-xl font-black text-white ${v.gate_pass_active ? "bg-emerald-600" : "bg-red-600"}`} data-testid="verify-status-banner">
              {v.gate_pass_active ? (
                <span className="inline-flex items-center gap-2"><ShieldCheck className="h-6 w-6" /> GATE PASS ACTIVE</span>
              ) : (
                <span className="inline-flex items-center gap-2"><ShieldX className="h-6 w-6" /> NOT AUTHORIZED</span>
              )}
            </div>
            <div className="flex gap-4 p-4">
              {v.photo_url ? (
                <img src={v.photo_url} alt={v.name} className="h-28 w-24 border-2 border-slate-900 object-cover" data-testid="verify-photo" />
              ) : (
                <div className="grid h-28 w-24 place-items-center border-2 border-slate-900 bg-slate-100 font-heading text-3xl font-black text-slate-400">{(v.name || "?")[0]}</div>
              )}
              <div className="min-w-0 flex-1 text-sm">
                <div className="truncate font-heading text-lg font-black text-slate-900" data-testid="verify-name">{v.name}</div>
                <div className="font-mono text-xs text-slate-500">ID: {v.id_card_no || "NOT ISSUED"}</div>
                <div className="mt-1.5">Trade: <b>{v.trade || "—"}</b></div>
                <div>Site: <b>{v.site || "—"}</b></div>
                <div>Contractor: <b>{v.contractor_name || "—"}</b></div>
                <div>Blood Group: <b>{v.blood_group || "—"}</b></div>
              </div>
            </div>
            <div className="border-t border-slate-200 px-4 py-2 text-center font-mono text-[10px] text-slate-500">
              Status: {(v.status || "").toUpperCase()} · Verified live from SWMS-MPDB · {new Date().toLocaleString()}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
